import { CheckIcon, XIcon } from '@zep/icons';
import { useViewportDevice } from '@zep/react';
import { Colors } from '@zep/ui-tokens';
import { usePricing } from '../PricingProvider';
export const PricingComparisonColumns = (props: PricingColumnsProps) => {
  const {
    access
  } = props;
  const {
    isMobile
  } = useViewportDevice();

  // @ts-ignore
  const {
    visiblePlans
  } = usePricing();
  const iconSize = isMobile ? 24 : 20;
  return <>
      {
    // @ts-ignore
    visiblePlans.map((plan, index) => {
      // @ts-ignore
      const value = access[plan];
      return <td key={index}>
              {typeof value === 'string' && value}

              {typeof value === 'boolean' && (value ? <CheckIcon width={iconSize} height={iconSize} color={plan === 'enterprise' ? Colors.Black : plan === 'basic' ? Colors.MintDark : Colors.PrimaryDefault} /> : <XIcon width={iconSize} height={iconSize} color={Colors.Gray400} />)}
            </td>;
    })}
    </>;
};
type PricingColumnsProps = {
  access: {
    free: boolean | string;
    basic: boolean | string;
    pro: boolean | string;
    enterprise: boolean | string;
  };
};